<page-header
  [title]="'app.dashboard.overview-of-carbon-emissions' | i18n"
  [breadcrumb]="breadcrumb"
  [action]="action"
  [content]="content"
>
  <ng-template #breadcrumb>
    <nz-breadcrumb>
      <nz-breadcrumb-item>
        <a routerLink="/">{{ 'app.home' | i18n }}</a>
      </nz-breadcrumb-item>
      <nz-breadcrumb-item><a routerLink="/dashboard">Dashboard</a></nz-breadcrumb-item>
    </nz-breadcrumb>
  </ng-template>
  <ng-template #action>
    <div>
      <div>
        <nz-select class="width-sm" [(ngModel)]="selectedYear" (ngModelChange)="yearChange($event)">
          <nz-option *ngFor="let item of yearData" [nzValue]="item.val" [nzLabel]="item.name" />
        </nz-select>
      </div>
    </div>
  </ng-template>
  <ng-template #content>
    <div class="show-step">
      <div class="step-container">
        <div>
          <nz-steps [nzCurrent]="-1">
            <nz-step
              [nzTitle]="'app.dashboard.overview-step-1-title' | i18n"
              [nzDescription]="'app.dashboard.overview-step-1-description' | i18n"
            />
            <nz-step
              [nzTitle]="'app.dashboard.overview-step-2-title' | i18n"
              [nzDescription]="'app.dashboard.overview-step-2-description' | i18n"
            />
            <nz-step
              [nzTitle]="'app.dashboard.overview-step-3-title' | i18n"
              [nzDescription]="'app.dashboard.overview-step-3-description' | i18n"
            />
          </nz-steps>
        </div>
        <div>
          <img src="../../../assets/guid/guid.png" height="68px" />
          <div style="height: 20px">
            <div>
              <ellipsis length="100">
                {{ 'app.dashboard.overview-step-detail' | i18n }}
              </ellipsis>
              <a routerLink="/support/operation">
                {{ 'app.dashboard.overview-step-guide' | i18n }}
              </a>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</page-header>
<full-content [fullscreen]="false">
  <!-- <div class="text-right text-3xl font-bold underline">Hello tailwindcss!</div> -->
  <!-- <nz-card style="margin-bottom: 16px">
    <editor [apiKey]="apiKey" [init]="config"></editor>
  </nz-card> -->
  <!-- <div style="width: 200px">
    <div style="width: 100%">
      <ellipsis lines="1" tooltip="false">
        <p>
          There were injuries alleged in three
          <a href="#cover">cases in 2015</a>
          , and a fourth incident in September, according to the safety recall report. After meeting
          with US regulators in October, the firm decided to issue a voluntary recall.
        </p>
      </ellipsis>
    </div>
  </div> -->
  <nz-card style="margin-bottom: 16px">
    <div class="container-dashboard">
      <div class="year">
        <div class="title">{{ 'app.dashboard.overview.annual-total' | i18n }}</div>
        <div class="content">
          <div class="content-title">
            <span>{{ 'app.dashboard.overview.annual-total-carbon-emissions' | i18n }}</span>
            <span>tCO₂e</span>
          </div>
          <div class="data">{{ yearStatistics.emission | number: '1.0-2' }}</div>
          <div>
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr *ngFor="let item of yearStatistics.sourceList">
                <td>
                  <div class="square"></div>
                </td>
                <td>{{ item.sourceTypeLabel }}</td>
                <td class="number">
                  {{ item.emission | number: '1.0-2' }}
                </td>
                <td>tCO₂e</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div>
        <chart-echarts #chart1 height="300px" [option]="option" />
      </div>
    </div>
  </nz-card>
  <nz-card style="margin-bottom: 16px">
    <div class="container-dashboard">
      <div class="year">
        <div class="title">{{ 'app.dashboard.overview.carbon-emissions-detail' | i18n }}</div>
        <div class="content">
          <div class="content-title">
            <span>{{ 'app.dashboard.overview.annual-total-carbon-emissions' | i18n }}</span>
            <span>tCO₂e</span>
          </div>
          <div class="data">{{ unitStatistics.emission | number: '0.0-2' }}</div>
          <div>
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr *ngFor="let item of unitStatistics.sourceList">
                <td>
                  <div class="square"></div>
                </td>
                <td>{{ item.sourceTypeLabel }}</td>
                <td class="number">{{ item.emission | number: '0.0-2' }}</td>
                <td>tCO₂e</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div>
        <div class="text-right">
          <nz-select
            class="width-sm"
            [(ngModel)]="selectedUnit"
            (ngModelChange)="unitChange($event)"
          >
            <nz-option *ngFor="let item of unitList" [nzValue]="item.val" [nzLabel]="item.name" />
          </nz-select>
        </div>
        <chart-echarts #chart2 height="300px" [option]="option2" />
      </div>
    </div>
  </nz-card>
  <nz-card style="margin-bottom: 16px">
    <div>
      <div class="carbon-flow-title">{{ 'app.dashboard.sangji.title' | i18n }}</div>
      <chart-echarts #chart3 [height]="sangjiHeight" [option]="option3" />
    </div>
  </nz-card>
  <nz-card>
    <div nz-row [nzGutter]="16">
      <div nz-col nzSpan="12">
        <nz-card
          [nzTitle]="'app.dashboard.overview.industry-guidelines' | i18n"
          [nzExtra]="extraTemplate"
        >
          <div
            class="guid"
            *ngFor="let item of guids | async"
            [title]="item.name"
            (click)="showFile(item.name)"
          >
            {{ item.name }}
          </div>
        </nz-card>
        <ng-template #extraTemplate>
          <a routerLink="/support/guid">{{ 'app.common.label.more' | i18n }}</a>
        </ng-template>
      </div>
      <div nz-col nzSpan="12">
        <nz-card
          [nzTitle]="'app.dashboard.overview.frequently-asked-question' | i18n"
          [nzExtra]="extraTemplate1"
        >
          <div
            class="guid"
            *ngFor="let item of questionsDataList | async"
            [title]="item.title"
            (click)="createTplModal(tplTitle, tplContent, tplFooter, item.title)"
          >
            {{ item.title }}
          </div>
        </nz-card>
        <ng-template #extraTemplate1>
          <a routerLink="/support/question">{{ 'app.common.label.more' | i18n }}</a>
        </ng-template>
        <ng-template #tplTitle>
          <span>{{ title2 }}</span>
        </ng-template>
        <ng-template #tplContent let-params>
          <p>{{ answer }}</p>
        </ng-template>
        <ng-template #tplFooter let-ref="modalRef">
          <button nz-button nzType="primary" (click)="ref.destroy()">OK</button>
        </ng-template>
      </div>
    </div>
  </nz-card>
</full-content>
<!-- <app-support-ai></app-support-ai> -->
